import { ReactChild } from 'react';
import styles from '../styles/flexRow.module.scss';

export default function FlexRow(props: {
  children: ReactChild[];
  gap?: number | string;
  justify?: 'space-around' | 'space-between' | 'stretch' | 'space-evenly';
  align?: 'center';
}) {
  return (
    <div
      className={styles.flex}
      style={{ gap: props.gap, justifyContent: props.justify, alignItems: props.align }}
    >
      {props.children}
    </div>
  );
}
